/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserReportControllerGetGenerationsReport200ResponseData } from './userReportControllerGetGenerationsReport200ResponseData';


export interface UserReportControllerGetGenerationsReport200Response { 
    statusCode?: number;
    success?: boolean;
    message?: string;
    data?: UserReportControllerGetGenerationsReport200ResponseData;
    error?: string;
}

